<div class="sidenav-content" cdkScrollable *ngIf="!submitting && !isLoading; else spinner">
	<copo-panel-header [isBackButtonVisible]="true" (backButtonClick)="goBack()"
		[titleHeaderText]="('guarantee.register'|translate) +' - '+ ('guarantee.magnelisbuilding.long'|translate)">
		<button type="button" mat-flat-button (click)="saveGuarantee($event)">
			<span translate>issue.save.as.drafts</span>
			<mat-icon iconPositionEnd class="save-icon" svgIcon="action_save"></mat-icon>
		</button>
		<button mat-flat-button type="button" color="primary" (click)="goToNextStep($event)">
			<span translate>issue.select.batches.action.next</span>
		</button>
	</copo-panel-header>
	<form>
		<div class="copo-form-container copo-grid">
			<copo-stepper class="copo-stepper-container" [steps]="steps"></copo-stepper>
			<copo-feedback-error></copo-feedback-error>
			<div class="copo-grid-row ">
				<div class="copo-grid-row-column">
					<h2 translate>guarantee.customer.information</h2>
				</div>
			</div>
			<div class="copo-grid-row grid-template-columns">
				<div class="copo-grid-row-column" #nameDiv>
					<mat-form-field>
						<mat-label translate>guarantee.project.name</mat-label>
						<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="35"
							[formControl]="projectNameFormControl" (change)="projectNameChanged($event)" required>
						<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
						</mat-icon>
						<mat-error *ngIf="projectNameFormControl.hasError('required')"><span
								translate>guarantee.project.name.mandatory</span>
						</mat-error>
					</mat-form-field>
				</div>
				<div class="copo-grid-row-column" #soldToDiv>
					<mat-form-field>
						<mat-label translate>guarantee.customer.name</mat-label>
						<mat-select (selectionChange)="soldToChanged($event)" [formControl]="soldToFormControl"
							required>
							<mat-option *ngFor="let corporate of soldTos" [value]="corporate.businessId">
								{{corporate.name}}
							</mat-option>
						</mat-select>
						<mat-error *ngIf="soldToFormControl.hasError('required')"><span
								translate>guarantee.corporate.name.mandatory</span>
						</mat-error>
					</mat-form-field>
				</div>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<h2 translate>guarantee.project.characteristics</h2>
				</div>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<span class="copo-label" translate>guarantee.planned.operations</span>
				</div>
			</div>
			<div class="copo-grid-row grid-template-columns">
				<mat-radio-group [formControl]="selectedOption" (change)="radioSelectionChanged($event.value)">
					<div class="copo-grid-row-column">
						<mat-radio-button class="mat-radio-button-guarantee" value="newBuildingCompleteConstruction">
							<span translate>guarantee.construction.new.building</span>
						</mat-radio-button>
					</div>
					<div class="copo-grid-row-column grid-row-corrector">
						<mat-radio-button class="mat-radio-button-guarantee" value="extensionExistingBuilding">
							<span translate>guarantee.extension.existing.building</span>
						</mat-radio-button>
					</div>
					<div class="copo-grid-row-column">
						<mat-radio-button class="mat-radio-button-guarantee" value="retrofittingRepairExistingBuilding">
							<span translate>guarantee.retrofitting.existing.building</span>
						</mat-radio-button>
					</div>
				</mat-radio-group>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<h2 class="copo-grid-row-column-top-margin" translate>guarantee.project.size</h2>
				</div>
			</div>
			<div class="copo-grid-row grid-template-columns">
				<mat-form-field class="copo-grid-row-column-input">
					<mat-label translate>guarantee.tonnage.magnelis</mat-label>
					<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="10"
						[formControl]="magnelisTonnageFormControl" (change)="magnelisTonnageNameChanged($event)">
					<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
					</mat-icon>
				</mat-form-field>
				<mat-form-field class="copo-grid-row-column-input">
					<mat-label translate>guarantee.surface.building</mat-label>
					<input type="text"  matInput copoInputNumber spellcheck="false" autocomplete="off" maxlength="10"
						[formControl]="powerFormControl" (change)="powerNameChanged($event)">
					<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
					</mat-icon>
				</mat-form-field>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<h2 class="copo-grid-row-header-top-margin" translate>guarantee.type.application</h2>
				</div>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<mat-checkbox labelPosition="after" [formControl]="roofingFormControl"
						(change)="roofingChanged($event.checked)">
						<span class="checkbox-label-wrapped" translate>guarantee.roofing</span>
					</mat-checkbox>
				</div>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<mat-checkbox labelPosition="after" [formControl]="wallFacadeFormControl"
						(change)="wallFacadeChanged($event.checked)">
						<span class="checkbox-label-wrapped" translate>guarantee.wall.facade</span>
					</mat-checkbox>
				</div>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<mat-checkbox labelPosition="after" [formControl]="compositeFloorFormControl"
						(change)="compositeFloorChanged($event.checked)">
						<span class="checkbox-label-wrapped" translate>guarantee.composite.floor</span>
					</mat-checkbox>
				</div>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<mat-checkbox labelPosition="after" [formControl]="perforatedSheetFormControl"
						(change)="perforatedSheetChanged($event.checked)">
						<span class="checkbox-label-wrapped" translate>guarantee.perforated.sheet</span>
					</mat-checkbox>
					<ng-container *ngIf="perforatedSheetFormControl.value === true">
						<div class="copo-grid-row-column">
							<div class="copo-grid-row-column">
								<mat-form-field>
									<mat-label translate>guarantee.per.rich </mat-label>
									<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="20"
										[formControl]="perSheetRichFormControl" (change)="perSheetRichChanged($event)">
									<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
										class="image-draft-list-icon"></mat-icon>
								</mat-form-field>
							</div>
						</div>
					</ng-container>
				</div>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<mat-checkbox labelPosition="after" [formControl]="coldFormedStrutFormControl"
						(change)="coldFormedStrutChanged($event.checked)">
						<span class="checkbox-label-wrapped" translate>guarantee.cold.structure
						</span>
					</mat-checkbox>
				</div>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<mat-checkbox labelPosition="after" [formControl]="rainWaterSystemsGuttersFormControl"
						(change)="rainWaterSystemsGuttersChanged($event.checked)">
						<span class="checkbox-label-wrapped" translate>guarantee.rainwater.systems</span>
					</mat-checkbox>
				</div>
			</div>
			<div class="copo-grid-row ">
				<div class="copo-grid-row-columns">
					<h2 class="copo-grid-row-header-top-margin" translate>guarantee.allocation.building</h2>
				</div>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<mat-checkbox labelPosition="after" [formControl]="residentialUseFormControl"
						(change)="residentialUseChanged($event.checked)">
						<span class="checkbox-label-wrapped" translate>guarantee.residential</span>
					</mat-checkbox>
				</div>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<mat-checkbox labelPosition="after" [formControl]="industrialFormControl"
						(change)="industrialChanged($event.checked)">
						<span class="checkbox-label-wrapped" translate>guarantee.industrial</span>
					</mat-checkbox>
				</div>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<mat-checkbox labelPosition="after" [formControl]="agriculturalFormControl"
						(change)="agriculturalChanged($event.checked)">
						<span class="checkbox-label-wrapped" translate>guarantee.agricultural</span>
					</mat-checkbox>
				</div>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<mat-checkbox labelPosition="after" [formControl]="otherADBFormControl"
						(change)="otherADBChanged($event.checked)">
						<span class="checkbox-label-wrapped" translate>guarantee.other.building</span>
					</mat-checkbox>
					<ng-container *ngIf="otherADBFormControl.value === true || agriculturalFormControl.value === true ||
					industrialFormControl.value === true || residentialUseFormControl.value === true">
						<div class="copo-grid-row-column">
							<div class="copo-grid-row-column">
								<mat-form-field>
									<mat-label translate>guarantee.purpose.building</mat-label>
									<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="20"
										[formControl]="otherADBSpecifyFormControl"
										(change)="otherADBSpecifyChanged($event)">
									<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
										class="image-draft-list-icon">
									</mat-icon>
								</mat-form-field>
							</div>
						</div>
					</ng-container>
				</div>
			</div>
			<div class="copo-grid-row ">
				<h2 class="copo-grid-row-columns copo-grid-row-header-top-margin" translate>guarantee.questions</h2>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
						<mat-form-field class="copo-grid-row-column">
							<mat-label translate>guarantee.inside-building.activity</mat-label>
							<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="100"
								[formControl]="acitivityInsideBuildingFormControl"
								(change)="acitivityInsideBuildingChanged($event)">
							<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
								class="image-draft-list-icon">
							</mat-icon>
						</mat-form-field>
				</div>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<div class="copo-grid-row-radio copo-grid-row-column-top-margin">
						<div class="copo-grid-row-column copo-grid-row-column-left-margin">
							<span translate>guarantee.storage.chemicals</span>
						</div>
						<div class="copo-grid-row-column">
							<mat-radio-group class="copo-guarantee-radio-group" labelPosition="before"
								[formControl]="presenceofChemicalFormControl"
								(change)="presenceofChemicalChanged($event)">
								<mat-radio-button class="copo-guarantee-radio" value="true">
									<span translate>guarantee.radio.yes</span>
								</mat-radio-button>
								<mat-radio-button class=" copo-guarantee-radio" value="false">
									<span translate>guarantee.radio.no</span>
								</mat-radio-button>
								<mat-radio-button class=" copo-guarantee-radio" value="">
									<span translate>guarantee.radio.na</span>
								</mat-radio-button>
							</mat-radio-group>
						</div>
					</div>
					<ng-container *ngIf="presenceofChemicalFormControl.value === 'true'">
							<mat-form-field class="copo-grid-row-column">
								<mat-label translate>guarantee.nature.content</mat-label>
								<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="100"
									[formControl]="natureContentFormControl"
									(change)="natureContentChanged($event)">
								<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
									class="image-draft-list-icon">
								</mat-icon>
							</mat-form-field>
					</ng-container>
				</div>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<div class="copo-grid-row-radio">
						<div class="copo-grid-row-column copo-grid-row-column-left-margin">
							<span translate>guarantee.storage.fermentation</span>
						</div>
						<div class="copo-grid-row-column">
							<mat-radio-group class="copo-guarantee-radio-group" labelPosition="before"
								[formControl]="presenceofFermentationFormControl"
								(change)="presenceofFermentationChanged($event)">
								<mat-radio-button class="copo-guarantee-radio" value="true">
									<span translate>guarantee.radio.yes</span>
								</mat-radio-button>
								<mat-radio-button class=" copo-guarantee-radio" value="false">
									<span translate>guarantee.radio.no</span>
								</mat-radio-button>
								<mat-radio-button class=" copo-guarantee-radio" value="">
									<span translate>guarantee.radio.na</span>
								</mat-radio-button>
							</mat-radio-group>
						</div>
					</div>
					<ng-container *ngIf="presenceofFermentationFormControl.value === 'true'">
						<mat-form-field class="copo-grid-row-column">
							<mat-label translate>guarantee.nature.content</mat-label>
							<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="100"
								[formControl]="natureContent2FormControl"
								(change)="natureContent2Changed($event)">
							<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
								class="image-draft-list-icon">
							</mat-icon>
						</mat-form-field>
					</ng-container>
				</div>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<mat-checkbox [formControl]="animalsBuildingFormControl" (change)="animalChanged($event.checked)">
						<span class="checkbox-label-wrapped" translate>guarantee.presence.animals</span>
					</mat-checkbox>
					<div class="copo-grid-row-column">
						<ng-container *ngIf="animalsBuildingFormControl.value === true">
							<div class="copo-grid-row">
								<div class="copo-grid-row-column">
									<mat-checkbox labelPosition="after" [formControl]="cattleFormControl"
										(change)="cattleChanged($event.checked)">
										<span class="checkbox-label-wrapped" translate>guarantee.cattle</span>
									</mat-checkbox>
								</div>
							</div>
							<div class="copo-grid-row">
								<div class="copo-grid-row-column">
									<mat-checkbox labelPosition="after" [formControl]="pigsFormControl"
										(change)="pigsChanged($event.checked)">
										<span class="checkbox-label-wrapped" translate>guarantee.pigs</span>
									</mat-checkbox>
								</div>
							</div>
							<div class="copo-grid-row">
								<div class="copo-grid-row-column">
									<mat-checkbox labelPosition="after" [formControl]="polutryFormControl"
										(change)="polutryChanged($event.checked)">
										<span class="checkbox-label-wrapped" translate>guarantee.Poultry</span>
									</mat-checkbox>
								</div>
							</div>
							<div class="copo-grid-row">
								<div class="copo-grid-row-column">
									<mat-checkbox labelPosition="after" [formControl]="otherAnimalsFormControl"
										(change)="otherAnimalsChanged($event.checked)">
										<span class="checkbox-label-wrapped" translate>guarantee.others.animals</span>
									</mat-checkbox>
									<ng-container *ngIf="otherAnimalsFormControl.value === true">
										<div class="copo-grid-row-column">
											<mat-form-field>
												<mat-label translate>guarantee.animals.inside.building
												</mat-label>
												<input type="text" matInput spellcheck="false" autocomplete="off"
													maxlength="100" [formControl]="animalsInsideBuildingFormControl"
													(change)="animalsInsideBuildingChanged($event)">
												<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
													class="image-draft-list-icon">
												</mat-icon>
											</mat-form-field>
										</div>
										
									</ng-container>
									<div class="copo-grid-row-column">
										<mat-form-field>
											<mat-label translate>guarantee.animals.density</mat-label>
											<input type="text" matInput copoInputNumber spellcheck="false" autocomplete="off"
												maxlength="100" [formControl]="densityofAnimalsFormControl"
												(change)="densityofAnimalsChanged($event)">
											<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
												class="image-draft-list-icon">
											</mat-icon>
										</mat-form-field>
									</div>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<mat-checkbox [formControl]="manureManagementFormControl" class="copo-guarantee-checkbox-placement"
						(change)="manureManagementChanged($event.checked)">
						<span class="checkbox-label-wrapped" translate>guarantee.manure.management</span>
					</mat-checkbox>
					<ng-container *ngIf="manureManagementFormControl.value === true">
						<div class="copo-grid-row-column">
							<div class="copo-grid-row-column">
								<mat-checkbox labelPosition="after"
									[formControl]="manureManagementGrantingsFormControl"
									(change)="manureManagementGrantingsChanged($event.checked)">
									<span class="checkbox-label-wrapped" translate>guarantee.gratings</span>
								</mat-checkbox>
							</div>
							<div class="copo-grid-row-column">
								<mat-checkbox labelPosition="after"
									[formControl]="manureManagementWOGrantingsFormControl"
									(change)="manureManagementWOGrantingsChanged($event.checked)">
									<span class="checkbox-label-wrapped" translate>guarantee.without.gratings</span>
								</mat-checkbox>
							</div>
						</div>
					</ng-container>
				</div>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<div class="copo-grid-row-radio copo-grid-row-column-top-margin">
						<div class="copo-grid-row-column copo-grid-row-column-left-margin">
							<span translate>guarantee.gas.building</span>
						</div>
						<div class="copo-grid-row-column">
							<mat-radio-group class="copo-guarantee-radio-group" labelPosition="before"
								[formControl]="gasVapourFormControl" (change)="gasVapourChanged($event)">
								<mat-radio-button class="copo-guarantee-radio" value="true">
									<span translate>guarantee.radio.yes</span>
								</mat-radio-button>
								<mat-radio-button class=" copo-guarantee-radio" value="false">
									<span translate>guarantee.radio.no</span>
								</mat-radio-button>
								<mat-radio-button class=" copo-guarantee-radio" value="">
									<span translate>guarantee.radio.na</span>
								</mat-radio-button>
							</mat-radio-group>
						</div>
					</div>
					<ng-container *ngIf="gasVapourFormControl.value === 'true'">
						<mat-form-field class="copo-grid-row-column">
							<mat-label translate>guarantee.nature.content</mat-label>
							<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="20"
								[formControl]="gasvaporNatureContentFormControl"
								(change)="gasvaporNatureContentChanged($event)">
							<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
								class="image-draft-list-icon">
							</mat-icon>
						</mat-form-field>
					</ng-container>
				</div>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<div class="copo-grid-row-radio">
						<div class="copo-grid-row-column copo-grid-row-column-left-margin">
							<span translate>guarantee.building.heated</span>
						</div>
						<div class="copo-grid-row-column">
							<mat-radio-group class="copo-guarantee-radio-group" labelPosition="before"
								[formControl]="buildingHeatedFormControl" (change)="buildingHeatedChanged($event)">
								<mat-radio-button class="copo-guarantee-radio" value="true">
									<span translate>guarantee.radio.yes</span>
								</mat-radio-button>
								<mat-radio-button class=" copo-guarantee-radio" value="false">
									<span translate>guarantee.radio.no</span>
								</mat-radio-button>
								<mat-radio-button class=" copo-guarantee-radio" value="">
									<span translate>guarantee.radio.na</span>
								</mat-radio-button>
							</mat-radio-group>
						</div>
					</div>
					<ng-container *ngIf="buildingHeatedFormControl.value === 'true'">
						<mat-form-field class="copo-grid-row-column">
							<mat-label translate>guarantee.heating.type
							</mat-label>
							<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="100"
								[formControl]="heatingTypeFormControl" (change)="heatingTypeChanged($event)">
							<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
							class="image-draft-list-icon">
							</mat-icon>
						</mat-form-field>
					</ng-container>
				</div>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<div class="checkbox-label-wrapped que-equipment" translate>guarantee.equipment</div>
					<div class="copo-grid-row-column">
						<div class="copo-grid-row">
							<div class="copo-grid-row-column">
								<mat-checkbox labelPosition="after" [formControl]="qiaExtractorFormControl"
									(change)="qiaExtractorChanged($event.checked)">
									<span class="checkbox-label-wrapped" translate>guarantee.extractor</span>
								</mat-checkbox>
							</div>
						</div>
						<div class="copo-grid-row">
							<div class="copo-grid-row-column">
								<mat-checkbox labelPosition="after" [formControl]="qiaChimneyFormControl"
									(change)="qiaChimneyChanged($event.checked)">
									<span class="checkbox-label-wrapped" translate>guarantee.chimney</span>
								</mat-checkbox>
							</div>
						</div>
						<div class="copo-grid-row">
							<div class="copo-grid-row-column">
								<mat-checkbox labelPosition="after"
									[formControl]="qiaNaturalventilationFormControl"
									(change)="qiaNaturalventilationChanged($event.checked)">
									<span class="checkbox-label-wrapped"
										translate>guarantee.natural.ventilation</span>
								</mat-checkbox>
							</div>
						</div>
						<div class="copo-grid-row">
							<div class="copo-grid-row-column">
								<mat-checkbox labelPosition="after"
									[formControl]="qiaForcedventilationFormControl"
									(change)="qiaForcedventilationChanged($event.checked)">
									<span class="checkbox-label-wrapped"
										translate>guarantee.forced.ventilation</span>
								</mat-checkbox>
							</div>
						</div>
						<div class="copo-grid-row">
							<div class="copo-grid-row-column">
								<mat-checkbox labelPosition="after" [formControl]="otherEquipmentFormControl"
									(change)="otherEquipmentChanged($event.checked)">
									<span class="checkbox-label-wrapped" translate>claim.sample.other
									</span>
								</mat-checkbox>
								<ng-container *ngIf="otherEquipmentFormControl.value === true">
									<div class="copo-grid-row-column">
										<mat-form-field>
											<mat-label translate>guarantee.specify</mat-label>
											<input type="text" matInput spellcheck="false" autocomplete="off"
												maxlength="100" [formControl]="specifyOtherEquipmentFormControl"
												(change)="specifyOtherEquipmentChanged($event)">
											<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
												class="image-draft-list-icon">
											</mat-icon>
										</mat-form-field>
									</div>
								</ng-container>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<div class="copo-grid-row-radio">
						<div
							class="copo-grid-row-column copo-grid-row-column-top-margin copo-grid-row-column-left-margin">
							<span translate>guarantee.condensation.rink
							</span>
						</div>
						<div class="copo-grid-row-column">
							<mat-radio-group class="copo-guarantee-radio-group" labelPosition="before"
								[formControl]="qiacondriskbuildingFormControl"
								(change)="qiacondriskbuildingChanged($event)">
								<mat-radio-button class="copo-guarantee-radio" value="true">
									<span translate>guarantee.radio.yes</span>
								</mat-radio-button>
								<mat-radio-button class=" copo-guarantee-radio" value="false">
									<span translate>guarantee.radio.no</span>
								</mat-radio-button>
								<mat-radio-button class=" copo-guarantee-radio" value="">
									<span translate>guarantee.radio.na</span>
								</mat-radio-button>
							</mat-radio-group>
						</div>
					</div>
					<ng-container *ngIf="qiacondriskbuildingFormControl.value === 'true'">
						<mat-form-field class="copo-grid-row-column">
							<mat-label translate>guarantee.relative.humidity</mat-label>
							<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="100"
								[formControl]="humiditySpecFormControl" (change)="humiditySpecChanged($event)">
							<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
								class="image-draft-list-icon">
							</mat-icon>
						</mat-form-field>
					</ng-container>
				</div>
			</div>
		</div>
	</form>
</div>
<ng-template #spinner>
	<copo-loading-spinner class="loading-spinner-container-padded"></copo-loading-spinner>
</ng-template>